import React from 'react';
import { FieldPathByValue, UseFormReturn } from 'react-hook-form';
import { CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import SubjectProfileDetailsConfigurationCheckboxList from './checkbox-list';
import Card from '@components-clean/core/card';
import { TextBoxController } from '@components-clean/core/text-box';
import { useTranslation } from '@hooks/index';
import { SubjectProfileDetailsConfigurationFormValues } from './types';

type CheckboxKey = FieldPathByValue<
    Exclude<SubjectProfileDetailsConfigurationFormValues['personalInformation'], null>,
    boolean | null
>;

const checkboxKeys: CheckboxKey[] = [
    'ageAtEnrolment',
    'gender',
    'race',
    'ethnicity',
    'latestConsentDate',
    'latestConsentVersion',
];

type Props = {
    control: UseFormReturn<SubjectProfileDetailsConfigurationFormValues>['control'];
    disabled: boolean;
};

const PersonalInformationCard = ({ control, disabled }: Props) => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'subjectConfig.subjectProfileDetailsConfig.personalInformation',
    });

    return (
        <Card padding="none" data-testid="subject-profile-details-configuration-personal-information">
            <CardHeader className="k-card-header">
                <CardTitle>{t('title')}</CardTitle>
            </CardHeader>

            <CardBody>
                <div>
                    <TextBoxController
                        control={control}
                        name="personalInformation.label"
                        required
                        maxLength={50}
                        label={`${t('field.label')}*`}
                        data-testid="checkbox-personalInformation-label"
                        disabled={disabled}
                    />
                </div>

                <SubjectProfileDetailsConfigurationCheckboxList
                    control={control}
                    disabled={disabled}
                    checkboxKeys={checkboxKeys.map((key) => ({
                        key: `personalInformation.${key}`,
                        label: t(`field.${key}`),
                    }))}
                />
            </CardBody>
        </Card>
    );
};

export default PersonalInformationCard;
